import React, { Component } from "react";
import { FcCancel, FcCheckmark } from "react-icons/fc";
import HttpService from "../../services/HttpService";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import RenderOnRole from "../../Utilities/RenderOnRole";
import UserService from "../../services/UserService";
import styled from "@emotion/styled";
import { RetryTooltip } from "./RetryTooltip";
import { saveAs } from "file-saver";

class BerichtRow extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      berichtObj: this.props.bericht,
      interfaceId: this.props.interfaceId,
      retrySuccess: null,
      retryError: null,
      key: this.props.key,
      selectedFule: null,
      fileContent: ""
    };
    // Reference to the file input element
    this.fileInputRef = React.createRef();
  }

  componentWillReceiveProps(props) {
    this.setState({
      berichtObj: props.bericht,
      interfaceId: props.interfaceId,
      key: props.key,
    });
  }

  componentDidMount() {
    const httpService = HttpService;
    httpService.configure();
    this.state.axios = httpService.getAxiosClient();
  }

  handleFileUpload = (connectmessageId, e) => {
    const { files } = e.target;
    if (files && files.length) {
      this.ResendMessage();
    }
  };

  handleRowClick = () => {
    this.props.onSelect(this.props.bericht);
  };

  render() {
    let berichtObj = this.state.berichtObj;
    console.log(berichtObj);
    console.log(this.state.interfaceId);
    let success = this.state.retrySuccess;
    const { isSelected } = this.props;
    const TableRowStyled = isSelected ? styled(TableRow)`
      {
        background-color: #0062ff;
      }
      & > td {
        color: black;
        border: black;
      }
    `:styled(TableRow)`
    &:nth-of-type(odd) {
      background-color: #b4cffa;
    }
    &:nth-of-type(even) {
      background-color: #c3d8fa;
    }
    & > td {
      color: black;
      border: black;
    }
  ` ;
  let statusSting = "";
  switch (berichtObj.status)
  {
    case "1":
      statusSting = "Ontvangen";
      break;
    case "2":
      statusSting = "wordt verwerkt";
      break;
    case "3":
      statusSting = "In retry";
      break;
    case "4":
      statusSting = "Afgeleverd";
      break;
    case "5":
      statusSting = "Afgeleverd";
      break;
    case "Verwerkt":
      statusSting = "Afgeleverd";
      break
    case "6":
      statusSting = "Kon niet afgeleverd worden";
      break;
  }
    return (
      <TableRowStyled
        key={this.state.key}
        className={ isSelected ? "bg-blue-300 border-black border-2" : "bg-blue-200 border-black border" }
        //className="bg-blue-200 border-black border"
        onClick={this.handleRowClick}
        style={{cursor:'pointer'}}
      >
        <TableCell>
          <input
            type="radio"
            checked={isSelected}
            onChange={this.handleRowClick}
          />
        </TableCell>
        <TableCell>{berichtObj.displayNaamVerzend}</TableCell>

        <TableCell>
          {berichtObj.glN_zender == null || berichtObj.glN_zender == "null"
            ? "-"
            : berichtObj.glN_zender}
        </TableCell>

        <TableCell>{berichtObj.displayNaamOntvangt}</TableCell>

        <TableCell>
          {berichtObj.glN_ontvanger == null ||
          berichtObj.glN_ontvanger == "null"
            ? "-"
            : berichtObj.glN_ontvanger}
        </TableCell>
        <TableCell>{berichtObj.functioneelID}</TableCell>
        <TableCell>{statusSting}</TableCell>
        <TableCell>
          {berichtObj.verzonden_datumtijd.split("+")[0].replace("T", " ")}
        </TableCell>

        <RenderOnRole roles={["SD_Medewerker", "Administrator"]}>
          <TableCell>{berichtObj.agentname}</TableCell>
        </RenderOnRole>
      </TableRowStyled>
    );
  }
}
export default BerichtRow;
